import { CustomError } from './custom-error';

export class BadRequestError extends CustomError {
  public readonly statusCode: number;

  constructor(message: string, data: object = {}) {
    super(message, data);
    this.name = 'BadRequestError';
    this.message = message;
    this.statusCode = 400;
  }
}
